<template>
  <div class="kk-designer__alignments-container">
    <div class="kk-designer__alignments">
      <div class="wrapper">
        <button data-test-id="align-vertical-top" text dense @click="setVerticalAlign('top')">
          <i class="icon-align-vertical-top"></i>
        </button>
        <tooltip v-if="showTooltip" :text="'T'" />
      </div>
      <div class="wrapper">
        <button data-test-id="align-vertical-center" text dense @click="setVerticalAlign('center')">
          <i class="icon-align-vertical-center"></i>
        </button>
        <tooltip v-if="showTooltip" :text="'M'" />
      </div>
      <div class="wrapper">
        <button data-test-id="align-vertical-bottom" text dense @click="setVerticalAlign('bottom')">
          <i class="icon-align-vertical-bottom"></i>
        </button>
        <tooltip v-if="showTooltip" :text="'B'" />
      </div>
    </div>
    <div class="kk-designer__alignments">
      <div class="wrapper">
        <button data-test-id="align-left" text dense @click="setTextAlign('left')">
          <i class="icon-format-align-left"></i>
        </button>
        <tooltip v-if="showTooltip" :text="'L'" :styles="{ transform: 'translate(0, 100%)' }" />
      </div>
      <div class="wrapper">
        <button data-test-id="align-center" text dense @click="setTextAlign('center')">
          <i class="icon-format-align-center"></i>
        </button>
        <tooltip v-if="showTooltip" :text="'C'" :styles="{ transform: 'translate(0, 100%)' }" />
      </div>
      <div class="wrapper">
        <button data-test-id="align-right" text dense @click="setTextAlign('right')">
          <i class="icon-format-align-right"></i>
        </button>
        <tooltip v-if="showTooltip" :text="'R'" :styles="{ transform: 'translate(0, 100%)' }" />
      </div>
    </div>
  </div>
</template>
<script>
import { HotkeyScopes } from "../../../../utils/constants";
import Tooltip from "../../../commons/Tooltip.vue";
import hotkeys from "hotkeys-js";
export default {
  components: {
    Tooltip,
  },
  emits: ["set-text-align", "set-vertical-align", "hide"],
  data() {
    return {
      showTooltip: false,
    };
  },
  mounted() {
    this.$store.dispatch("setScope", HotkeyScopes.Alignments);
    hotkeys("l, c, r, t, m, b, escape", HotkeyScopes.Alignments, (event, handler) => {
      event.preventDefault();
      switch (handler.key) {
        case "l":
          this.setTextAlign("left", true);
          break;
        case "r":
          this.setTextAlign("right", true);
          break;
        case "c":
          this.setTextAlign("center", true);
          break;
        case "t":
          this.setVerticalAlign("top", true);
          break;
        case "m":
          this.setVerticalAlign("center", true);
          break;
        case "b":
          this.setVerticalAlign("bottom", true);
          break;
        case "escape":
          this.$emit("hide");
          break;
      }
    });
  },
  beforeUnmount() {
    hotkeys.unbind("l, c, r, t, m, b, escape", HotkeyScopes.Alignments);
    this.$store.dispatch("setScope", HotkeyScopes.EditToolBox);
  },
  methods: {
    setTextAlign(align, showTooltip) {
      this.$emit("set-text-align", align, showTooltip);
    },
    setVerticalAlign(align, showTooltip) {
      this.$emit("set-vertical-align", align, showTooltip);
    },
  },
};
</script>
<style lang="less">
@import "../../../../assets/styles/variables";

.kk-designer__alignments {
  display: flex;
  &-container {
    position: absolute;
    transform: translate(0, 90%);
    border-radius: 8px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    border: 0.5px solid lightgray;
    padding: 0.3rem;
    background-color: @kk-color-background;
  }
}
</style>
